import { CssBaseline } from '@mui/material';
import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { InvitationPage } from './ui/pages/InvitationPage';
import { QueryProvider } from './ui/providers/QueryProvider';
import { LocaleProvider } from './ui/providers/LocaleProvider';

// Temporaire, c'est pour jouer sur l'envrironnement de playground, le temps que console soit câblé
const isDev = 1 == 1;
const DevTestPageLazy = isDev
  ? lazy(() =>
      import('./ui/pages/DevTestPage').then((m) => ({
        default: m.DevTestPage,
      })),
    )
  : null;

const ConsoleDemoPageLazy = isDev
  ? lazy(() =>
      import('./ui/pages/ConsoleDemoPage').then((m) => ({
        default: m.ConsoleDemoPage,
      })),
    )
  : null;

const OuiFactureDemoPageLazy = isDev
  ? lazy(() =>
      import('./ui/pages/OuiFactureDemoPage').then((m) => ({
        default: m.OuiFactureDemoPage,
      })),
    )
  : null;

function App() {
  return (
    <LocaleProvider>
      <QueryProvider>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<InvitationPage />} />
            {isDev && DevTestPageLazy && (
              <Route
                path="/dev/test"
                element={
                  <Suspense fallback={<div>Chargement…</div>}>
                    <DevTestPageLazy />
                  </Suspense>
                }
              />
            )}
            {isDev && ConsoleDemoPageLazy && (
              <Route
                path="/dev/console"
                element={
                  <Suspense fallback={<div>Chargement…</div>}>
                    <ConsoleDemoPageLazy />
                  </Suspense>
                }
              />
            )}
            {isDev && OuiFactureDemoPageLazy && (
              <Route
                path="/dev/OuiFacture"
                element={
                  <Suspense fallback={<div>Chargement…</div>}>
                    <OuiFactureDemoPageLazy />
                  </Suspense>
                }
              />
            )}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </QueryProvider>
    </LocaleProvider>
  );
}

export default App;
